import { RadioGroup as RadixRadioGroup } from "radix-ui";
import { ReactNode } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

interface RadioGroupProps {
  value?: string;
  onValueChange?: (value: string) => void;
  name?: string;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export function RadioGroup({
  value,
  onValueChange,
  name,
  disabled,
  className,
  children,
}: RadioGroupProps) {
  return (
    <RadixRadioGroup.Root
      value={value}
      onValueChange={onValueChange}
      name={name}
      disabled={disabled}
      className={twMerge(clsx("space-y-4", className))}
    >
      {children}
    </RadixRadioGroup.Root>
  );
}
